module.exports = __webpack_public_path__ + "img/qcode.c5284061.jpg";